// extracted by mini-css-extract-plugin
export default {"SubTopicContainer":"SubTopic_SubTopicContainer__JWn8G"};